const ACTIVE_CLASS = 'is-active';

let _selectors = {
    navbar: '.navbar',
    navbarBrand: '.navbar-brand',
    submenuParent: '.menu-item-has-children',
    submenuToggle: '.menu-item-has-children > a',
    submenuActive: '.menu-item-has-children.is-active > div.submenu',
    submenuBack: '.submenu-trigger',
    navDrawer: '.js-navdrawer',
    navDrawerToggle: '.js-navdrawer-toggle',
    menuToggle: '.menu-toggle',
    navMenu: '.nav-menu[role="navigation"]'
};

// Cached elements
let _el = {};

// Module variables
let _vars = {};

// Module init
const _init = () => {
    // Define & cache elements
    _setElements();

    // Bind events
    if (_vars.submenuParent) {
        _bindEvents();
    }

    $(_selectors.menuToggle).on('click', (event) => {
        _toggleMainMenu(event);
    });
};

const _bindEvents = () => {
    _el.submenuToggle.on('click', function(e) {
        // prevent menu-item with children redirecting page
        e.preventDefault();
        e.stopPropagation();

        // handle open/close submenu
        _toggleMenu($(this));

        // aquire offset of current submenu parent item
        _retrieveOffsetHeight($(this));

        // rerun offset aquisition on resize
        $(window).on('resize', event => _retrieveOffsetHeight($(this)));
    });

    // handle menu back button on small devices
    _el.submenuBack.on('click', event => _toggleMenu($(this)));

    // handle toggle of multisite nav drawer
    _el.navDrawerToggle.on('click', event => _toggleNavDrawer());
};

const _toggleMainMenu = (event) => {
    if (_vars.navMenu) {
        _el.navMenu.toggleClass('active');
    }
    _el.menuToggle.toggleClass('active');
    document.querySelector('body').classList.toggle('main-nav-active');
};

const _toggleMenu = (submenuToggle) => {
    var submenu = submenuToggle.parent(_el.submenuParent);

     _hideOtherMenus(submenu);
    
    if (submenu.hasClass(ACTIVE_CLASS)) {                  
        submenu.removeClass(ACTIVE_CLASS);
    } else {
        submenu.addClass(ACTIVE_CLASS); 
    }
};

const _toggleNavDrawer = () => {
    $(_el.navDrawer).toggleClass(ACTIVE_CLASS);
}

const _hideOtherMenus = (submenu) => {
    _el.submenuParent.each(function(i, element) {
        if(!$(this).is(submenu) && !$(this).find(submenu).length ) {
            $(this).removeClass(ACTIVE_CLASS);
        }
    })
}

// retrieve height off offset hero image and apply to main hero wrapper as css variable
const _retrieveOffsetHeight = (submenuToggle) => {
    var offsetHeight = $(submenuToggle)[0].getBoundingClientRect().top;
    var menuItemHeight = $(submenuToggle).height();

    $(submenuToggle).parent(_el.submenuParent).children('.submenu').css({
        "--navOffset": offsetHeight + 'px',
        "--navItemHeight": menuItemHeight + 'px'
    });
}

// Set/Reset and Cache Module elements
const _setElements = () => {
    // Cache Elements into _el & create variable to check existence
    Object.keys(_selectors).forEach(key => {
        const el = $(_selectors[key]);

        _el[key] = el;
        _vars[key] = el.length;
    });
};

const Navigation = {
    init: _init,
};

export default Navigation;